import React, { useEffect, useState } from "react";
import { Row, Col, Button, Tag, Input, Modal, notification, Form, Table, Select } from "antd";
import { EditOutlined, DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import api from "../../services/api";
import { ModalItemInventario } from "../../components/modals";
import { TabelaDados } from "../../components";
import { listagemActions } from "../../actions";
import { useStateValue } from '../../state';
import moment from "moment";
import { FormatNumber } from "../../ValueObjects";


export default function Itens({ form, dadosItens, TipoCodigoProduto, onCloseModalItem }) {

    const [{ manutencao, ui }, dispatch] = useStateValue();
    const [dadosTipoCodigo, setDadosTipoCodigo] = useState([]);
    const [abrirModalItem, setAbrirModalItem] = useState();
    const [dadosRegistro, setDadosRegistro] = useState({});
    const [listaItem, setListaItem] = useState([]);
    const [filtro, setFiltro] = useState(0);

    const onCloseModal = () => {
        setAbrirModalItem(false);
        onCloseModalItem();
    };
    const [situacao] = useState({
        0: 'Falta',
        1: 'Ok',
        2: 'Sobra'
    });

    useEffect(() => {
        carregarTipoCodigo();
    }, []);


    function carregarTipoCodigo() {
        api.get('Enum/Listar?nome=TipoCodigoProdutoUtilizar').then(
            res => {
                setDadosTipoCodigo(res.data);
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        )
    };

    function defineFiltro(valor) {
        setFiltro(valor);
    };

    const verificaSituacao = record => {
        let retorno = 0;
        if (record.ivi_estoqueanterior > record.ivi_estoqueatual) {
            retorno = 0;
        } else if (record.ivi_estoqueanterior === record.ivi_estoqueatual) {
            retorno = 1;
        } else if (record.ivi_estoqueanterior < record.ivi_estoqueatual) {
            retorno = 2;
        }
        return retorno;
    };
    const filtroItens = valor => {
        api.get(`Inventario/ListarItens?InventarioId=${form.getFieldValue().inv_id}&Filtro=${valor}&PageSize=100&Order=-ivi_id&PageNumber=1`).then(

            res => {
                res.data.items.forEach(item => {
                    item.situacao_id = verificaSituacao(item);
                    item.situacao = situacao[verificaSituacao(item)];
                });
                setListaItem(res.data.items);
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        )
    };

    useEffect(() => {
        if (!!dadosItens.listaDadosItens) {
            setListaItem(dadosItens.listaDadosItens);
            if (!!form.getFieldValue().pesquisa) {
                filtroItens(form.getFieldValue().pesquisa);
            }
        }
    }, [dadosItens.listaDadosItens]);

    function excluirItem(dados) {
        Modal.confirm({
            title: `Remover produto ${dados.pro_descricao}?`,
            icon: <ExclamationCircleOutlined />,
            onOk() {
                api.delete(`Inventario/RemoverItem/${dados.ivi_id}`).then(
                    res => {
                        notification.success({ description: 'Item do inventário excluído com sucesso!', message: 'Aviso!' });
                    }
                ).catch(
                    erro => {
                        console.log(erro);
                    }
                ).finally(
                    () => {
                        onCloseModalItem();
                    }
                )
            }
        });
    };
    return (
        <div>
            <Row gutter={[16, 0]} align="middle">
                {/* Ver para inplementar mais opçoes de filtro, tipo estoque negativos, se custo medio, sem custo atual.... */}
                {/* <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                    <Form.Item label="Localizar Por" name="localizarPor">
                        <Select placeholder="Localize o Produto" onChange={(valor) => { defineFiltro(valor) }}>
                            {dadosTipoCodigo.map((tipoCodigo) => (
                                <Select.Option value={tipoCodigo.key} key={tipoCodigo.key}>{tipoCodigo.value}</Select.Option>
                            ))}

                        </Select>
                    </Form.Item>
                </Col> */}
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Form.Item name="pesquisa">
                        <Input.Search placeholder={"Código, descrição"} onSearch={valor => { filtroItens(valor) }} allowClear />
                    </Form.Item>
                </Col>
            </Row>
            <div className="tabela mt-dif">
                <Table dataSource={listaItem} columns={[
                    {
                        title: 'Código',
                        width: '4%',
                        align: 'center',
                        fixed: 'left',
                        render: ({ pro_codigo }) => (
                            <Tag color="processing" className="w-100">
                                <b>{pro_codigo}</b>
                            </Tag>
                        ),
                    },
                    {
                        title: 'Produto',
                        width: '15%',
                        fixed: 'left',
                        render: ({ pro_descricao }) => (
                            <div>
                                <b>{pro_descricao}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Grade',
                        width: '8%',
                        render: ({ grade }) => (
                            <div>
                                <b>{grade}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Data Posição',
                        align: 'center',
                        width: '7%',
                        render: ({ ivi_dataposicao }) => (
                            <div>
                                <b>{ivi_dataposicao ? moment(ivi_dataposicao).format('DD/MM/YYYY HH:mm') : ""}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Qtde. Anterior',
                        align: 'right',
                        width: '5%',
                        render: ({ ivi_estoqueanterior }) => (
                            <div>
                                <b>{FormatNumber(ivi_estoqueanterior, true, 3)}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Qtde. Atual',
                        align: 'right',
                        width: '5%',
                        render: ({ ivi_estoqueatual }) => (
                            <div>
                                <b>{FormatNumber(ivi_estoqueatual, true, 3)}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Custo Médio',
                        align: 'right',
                        width: '5%',
                        render: ({ ivi_customedio }) => (
                            <div>
                                <b>{FormatNumber(ivi_customedio, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Custo Atual',
                        align: 'right',
                        width: '4%',
                        render: ({ ivi_custoultimacompra }) => (
                            <div>
                                <b>{FormatNumber(ivi_custoultimacompra, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Situação',
                        align: 'center',
                        width: '5%',
                        render: ({ situacao_id, situacao }) => (
                            <Tag color={situacao_id === 0 ? "volcano" : (situacao_id === 1 ? "green" : "gold")} >
                                {situacao}
                            </Tag>
                        ),
                    },
                    {
                        title: 'Ações',
                        dataIndex: '',
                        key: 'x',
                        align: 'center',
                        fixed: 'right',
                        width: '4%',
                        render: (record) => (
                            <div>
                                <Row align="middle" justify="center" gutter={[5, 0]}>
                                    <Col>
                                        <Button onClick={() => {
                                            setAbrirModalItem(true);
                                            setDadosRegistro(record);
                                        }} icon={<EditOutlined />} />
                                    </Col>
                                    <Col>
                                        <Button onClick={() => {
                                            excluirItem(record)
                                        }} icon={<DeleteOutlined />} />
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                ]} scroll={{ x: 900 }} />
            </div>
            <ModalItemInventario form={form} dadosItem={dadosRegistro} exibirModal={abrirModalItem} onCloseModal={onCloseModal} TipoCodigoProduto={TipoCodigoProduto} />
        </div>
    );

}